export const {
  STAGING_APP_PLATFORM_ID = "1b00e08b-73ca-47c2-b288-49ce5bd45403",
  STAGING_APP_PLATFORM_ID_QA = "9ada4dbe-ba31-48a9-8259-91a0d87832a5",
  NFL_WEB_PLATFORM_ID = "10f64c69-4871-4a27-b2bd-3e34bece7c8e",
  NFL_WEB_PLATFORM_ID_PROD = "09dc4fe6-dc7f-4ee8-ab56-f4fa5e954fbf",
  NFL_VIZIO_PLATFORM_ID = "ac308629-01ec-46ef-a405-f12e90a38776",

  NAMI_SDK_STATE_KEY = "nami_sdk_state",
  NAMI_PAYWALL_CONTEXT = "nami_paywall_context",
  NAMI_SHOW_PAYWALL = "nami_show_paywall",
} = {};
